// IKaratWiseRate type is not yet available from @repo/connection-manager/types.
// Using a local placeholder until the dependency is resolved.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type IKaratWiseRate = Record<string, unknown>;
import { API_PATHS } from "../constants/api-paths";
import { GLCalculatorConstant, NEW_GL_API_CONSTANTS } from "../constants/util";
import { logErrorToNewRelic } from "../utils/logging";
import { createCacheAsync } from "@repo/shared-utils/cache";
import { getCookie, setCookie } from "@repo/shared-utils/common-utils";
import { request } from "../core/api.client";

export const fetchGoldRate = async (): Promise<number> => {
  try {
    const response = <
      {
        data: {
          rateResponse: {
            data: {
              dailyRate: string;
              effectiveDate: string;
            };
          };
          karatWiseRate: Array<{
            dailyRate: string;
            effectiveDate: string;
            fundingType: string;
            fundingRate: string;
            purity: string;
          }>;
          description: string;
          statusCode: string;
        };
        statusCode: number;
        status: string;
        message: string;
      }
    >await request({ method: "POST", url: API_PATHS.goldRate });

    let dailyGoldRate = 0;

    // Store daily gold rate
    if (response?.statusCode === 90 && response?.data?.rateResponse?.data?.dailyRate) {
      dailyGoldRate = Number(response.data.rateResponse.data.dailyRate);
      if (dailyGoldRate > 0) {
        setCookie(
          GLCalculatorConstant.GOLD_RATE,
          GLCalculatorConstant.GOLD_RATE_EXPIRY_TIME,
          dailyGoldRate.toString()
        );
        localStorage.setItem(GLCalculatorConstant.GOLD_RATE, dailyGoldRate.toString());
      }
    }

    // Store karat-wise rates in separate cookie
    if (
      response?.statusCode === 90 &&
      response?.data?.karatWiseRate &&
      Array.isArray(response.data.karatWiseRate)
    ) {
      try {
        const karatWiseRatesJson = JSON.stringify(response.data.karatWiseRate);
        setCookie(
          NEW_GL_API_CONSTANTS.KARAT_WISE_RATES,
          NEW_GL_API_CONSTANTS.EXPIRY_TIME,
          karatWiseRatesJson
        );
        localStorage.setItem(NEW_GL_API_CONSTANTS.KARAT_WISE_RATES, karatWiseRatesJson);
      } catch (error) {
        logErrorToNewRelic("Error storing karat-wise rates", { error: String(error) });
      }
    }

    return dailyGoldRate;
  } catch (error) {
    logErrorToNewRelic("Error fetching gold rate", { error: String(error) });
    const previousGoldRate = Number(localStorage.getItem(GLCalculatorConstant.GOLD_RATE));
    return previousGoldRate;
  }
};

export const CurrentGoldRate = async (): Promise<number> => {
  let goldRate = 0;
  const goldRateFromCookie = +getCookie(GLCalculatorConstant.GOLD_RATE);
  if (goldRateFromCookie) {
    goldRate = goldRateFromCookie;
  } else {
    goldRate = await createCacheAsync("currentGoldRate", fetchGoldRate);
  }
  return goldRate;
};

/**
 * Retrieves karat-wise rates from cookie or localStorage
 * @returns Array of karat-wise rates or empty array if not found
 */
export const getKaratWiseRates = (): IKaratWiseRate[] => {
  try {
    // Try to get from cookie first
    const karatRatesFromCookie = getCookie(NEW_GL_API_CONSTANTS.KARAT_WISE_RATES);
    if (karatRatesFromCookie) {
      return JSON.parse(karatRatesFromCookie);
    }

    // Fallback to localStorage
    const karatRatesFromLocalStorage = localStorage.getItem(NEW_GL_API_CONSTANTS.KARAT_WISE_RATES);
    if (karatRatesFromLocalStorage) {
      return JSON.parse(karatRatesFromLocalStorage);
    }

    return [];
  } catch (error) {
    logErrorToNewRelic("Error retrieving karat-wise rates", { error: String(error) });
    return [];
  }
};
